var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"673beb38863d3cb10c4cc1c54f83458d0eaba559"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yoco-com@yoco-technologies"]={id:"673beb38863d3cb10c4cc1c54f83458d0eaba559"};
      